<template>
  <div class="shinetop">
    <div class="inputGroup">
      <div :v-if="calssList.length" class="search">
        <el-select v-model="choose" placeholder="展品分类" class="input1">
          <el-option v-for="item in calssList" :key="item.url" :label="item.class_name_cn" :value="item.id" > </el-option>
        </el-select>
        <el-input v-model="product" placeholder="请输入展品名称" class="input2" ></el-input>
        <el-button class="searchFillet" icon="el-icon-search" @click="searchSelect" ></el-button>
      </div>
      <div class="search">
        <el-input v-model="merchant" placeholder="请输入展商名称"></el-input>
        <el-button class="searchFillet" icon="el-icon-search" @click="seachInput(true)" ></el-button>
      </div>
    </div>
    <div class="booth_figure">
      <div class="f_l">
        <div>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/bg_cn.png" />
          <div class="f_l_position">
            <img 
              :class="activeIndex == 'E1' ? 'opacity1' : ''" 
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/E1.png"
              alt="天然气"
            />
            <img
              :class="activeIndex == 'E2' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/E2.png"
              alt="氢能源"
            />
            <img
              :class="activeIndex == 'E3' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/E3.png"
              alt="管道与存储"
            />
            <img
              :class="activeIndex == 'E4' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/E4.png"
              alt="燃气技术"
            />
            <img
              :class="activeIndex == 'W1' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/W1.png"
              alt="非开挖技术"
            />
            <img
              :class="activeIndex == 'W2' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/W2.png"
              alt="防爆与仪器仪表"
            />
            <img
              :class="activeIndex == 'W3' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/W3.png"
              alt="国际展团、德国展团"
            />
            <img
              :class="activeIndex == 'W4' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/W4.png"
              alt="页岩气"
            />
          </div>
          <div class="f_l_text">
            <dl class="W W4">
              <dd>H2氢能装备</dd>
              <dd>制、储、运、加、用</dd>
            </dl>
            <dl class="W W3">
              <dd>管道/流体机械</dd>
              <dd>仪器仪表</dd>
            </dl>
            <dl class="W W2">
              <dd>国际展区</dd>
              <dd>海洋工程</dd>
            </dl>
            <dl class="W W1">
              <dd>国际展团</dd>
              <dd>海洋石油</dd>
            </dl>
            <dl class="E E4">
              <dd>天然气/燃气</dd>
              <dd>防爆/安全防护</dd>
            </dl>
            <dl class="E E3">
              <dd>石油装备/页岩气</dd>
              <dd>流体机械/仪表及电气</dd>
            </dl>
            <dl class="E E2">
              <dd>中石化展团</dd>
              <dd>石油勘探/钻采设备</dd>
            </dl>
            <dl class="E E1">
              <dd>中石油展团</dd>
              <dd>石油勘探/钻采设备</dd>
            </dl>
          </div>
          <div class="hot">
            <span class="w4" @click="shiJump('W4')" @mouseover="activeMove('W4')"></span>
            <span class="w3" @click="shiJump('W3')" @mouseover="activeMove('W3')"></span>
            <span class="w2" @click="shiJump('W2')" @mouseover="activeMove('W2')"></span>
            <span class="w1" @click="shiJump('W1')" @mouseover="activeMove('W1')"></span>
            <span class="e4" @click="shiJump('E4')" @mouseover="activeMove('E4')"></span>
            <span class="e3" @click="shiJump('E3')" @mouseover="activeMove('E3')"></span>
            <span class="e2" @click="shiJump('E2')" @mouseover="activeMove('E2')"></span>
            <span class="e1" @click="shiJump('E1')" @mouseover="activeMove('E1')"></span>
          </div>
        </div>
        <div>
          <img style="opacity:0" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E1.png"/>
          <div class="f_l_position zgt">
            <img
              :class="activeIndex == 'W1' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_W1.png"
              alt="W1"
            />
            <img
              :class="activeIndex == 'W2' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_W2.png"
              alt="W2"
            />
            <img
              :class="activeIndex == 'W3' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_W3.png"
              alt="W3"
            />
            <img
              :class="activeIndex == 'W4' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_W4.png"
              alt="W4"
            />
            <img
              :class="activeIndex == 'E1' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E1.png"
              alt="E1"
            />
            <img
              :class="activeIndex == 'E2' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E2.png"
              alt="E2"
            />
            <img
              :class="activeIndex == 'E3' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E3.png"
              alt="E3"
            />
            <img
              :class="activeIndex == 'E4' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E4.png"
              alt="E4"
            />
          </div>
        </div>
      </div>
      <div class="f_r">
        <ul>
          <li
            :class="activeIndex == item.url ? 'li_item li_item_active' : 'li_item'"
            v-for="(item, i) in list"
            :key="i"
            @mouseover="activeMove(item.url)"
            @click="shiJump(item.url)"
          >
            <div>
              <p>
                <span v-for="(value, j) in item.arr" :key="j + 'item'">
                  {{ value }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { reqSortList } from "../../../api";
const list = [
  {
    arr: ["H2氢能装备","制、储、运、加、用"],
    url: "W4",
  },
  {
    arr: ["天然气/燃气","防爆/安全防护"],
    url: "E4",
  },
  {
    arr: ["管道/流体机械","仪器仪表"],
    url: "W3",
  },
  {
    arr: ["石油装备/页岩气","流体机械/仪表及电气"],
    url: "E3",
  },
  {
    arr: ["国际展区","海洋工程"],
    url: "W2",
  },
  {
    arr: ["中石化展团","石油勘探/钻采设备"],
    url: "E2",
  },
  {
    arr: ["国际展团","海洋石油"],
    url: "W1",
  },
  {
    arr: ["中石油展团","石油勘探/钻采设备"],
    url: "E1",
  }
];
export default {
  data() {
    return {
      choose: "", //展品分类选择
      product: "", //展品名称
      merchant: "", //展商名称
      calssList: [], //数据
      opacit: "w1", //当前选择
      list: list,
      pavilionList: [
        {
          title: "E1馆",
          arr: ["zgxgqy_W2.png"],
        },
      ],
      activeIndex: 'W4', //高亮
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    activeMove(i) {
      this.activeIndex = i;
    },
    async init() {
      // 获取展品分类
      const response = await reqSortList();
      if (response.code == 0) {
        this.calssList = [
          { url: 0, class_name_cn: "全部", id: 0 },
          ...response.resilt,
        ];
      }
    },
    searchSelect() {
      // 展品选择搜索
      // let barList = [...this.calssList]
      let choose = this.choose;
      let product = this.product;
      sessionStorage.setItem("goodsData", JSON.stringify({ choose, product }));
      this.$router.push("/exhibit");
    },
    seachInput() {
      // 展商搜索
      let value = this.merchant;
      sessionStorage.setItem("merchant", JSON.stringify(value));
      this.$router.push("/exhibitor");
    },
    shiJump(value) {
      //跳转
      sessionStorage.setItem("pavilion", JSON.stringify(value));
      this.$router.push("/exhibitor");
    },
  },
  computed: {
    activeNape: () => {
      return 1;
    },
  },
};
</script>
<style scoped>
.inputGroup {
  display: flex;
  justify-content: space-between;
  padding-top: 43px;
  padding-bottom: 60px;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  z-index: 1;
}
.inputGroup > div {
  width: 46%;
}
.el-select {
  height: 40px;
  width: 28%;
  border-right: none;
}
.query >>> .el-input__inner,
.query >>> .el-select-dropdown__item {
  color: #333;
}
.search >>> .el-input__inner {
  height: 40px;
  padding: 0 20px;
  border-radius: 40px 0 0 40px;
  font-size: 12px;
  border-right: none;
}
.el-input {
  width: 80%;
}
.search .input1 >>> .el-input__inner {
  color: white;
  background-color: #f08300;
}
.search .input1 >>> .el-input__icon {
  width: 14px;
  color: white;
  line-height: 40px;
}
.search .input2 {
  width: 58%;
}
.search .input2 >>> .el-input__inner {
  border-radius: 0;
}
.search .el-button {
  height: 40px;
  width: 14%;
  border-left: none;
  padding: 6px 14px 6px 8px;
  font-size: 20px;
  background-color: #f5f7fa;
  color: #037d9d;
  border-radius: 0 40px 40px 0;
  vertical-align: top;
}
.search >>> .el-input__inner:focus,
.search >>> .el-button:focus {
  border-color: #c0c4cc;
}
.search >>> .el-select-dropdown__item {
  font-size: 12px;
}
/deep/.input1 input::-webkit-input-placeholder {
  color: #fff;
}
/deep/.input1 input::-moz-input-placeholder {
  color: #fff;
}
/deep/.input1 input::-ms-input-placeholder {
  color: #fff;
}
.navImg {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
<style scoped>
.shinetop {
  background: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/nav_bg.jpg") no-repeat;
  background-size:  100% 100%;
  background-position: center;
  padding-bottom: 50px;
}
.booth_figure {
  margin-left: -100%;
  height: 100%;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.f_l {
  display: inline-block;
  width: 58%;
  max-width: 658px;
  /* height: 400px; */
  /* background-color: seagreen; */
  vertical-align: top;
}
.f_l > div {
  position: relative;
  width: 100%;
}
.f_l_position {
  width: 100%;
  overflow: visible;
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
}
.f_l_position img {
  position: absolute;
  left: 0;
  top: 0;
  height: auto;
  opacity: 0;
  transition: all 0.5s;
}
.f_l_text{
  position: absolute;
  left: 118px;
  right: 128px;
  top: 27px;
  bottom: 83px;
}
.f_l_text .W{
  position: absolute;
  left: 0;
  width: 144px;
  height: 76px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.f_l_text .E{
  position: absolute;
  right: 0;
  width: 144px;
  height: 76px;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.f_l_text .W3,
.f_l_text .E3{
  top: 115px;
}
.f_l_text .W2,
.f_l_text .E2{
  top: 209px;
}
.f_l_text .W1,
.f_l_text .E1{
  bottom: 0;
}
/* 热点覆盖 start */
.hot {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.hot span {
  position: absolute;
  display: inline-block;
  width: 184px;
  /* width: 26.43%; */
  height: 80px;
  cursor: pointer;
  background-image: url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png');
}
.hot .w4 {
  left: 13.8%;
  top: 6.5%;
}
.hot .w3 {
  left: 13.8%;
  top: 28.5%;
}
.hot .w2 {
  left: 13.8%;
  top: 46.5%;
}
.hot .w1 {
  left: 13.8%;
  top: 68.5%;
}
.hot .e4 {
  left: 54%;
  top: 6.5%;
}
.hot .e3 {
  left: 54%;
  top: 28.5%;
}
.hot .e2 {
  left: 54%;
  top: 46.5%;
}
.hot .e1 {
  left: 54%;
  top: 68.5%;
}
/* 热点覆盖 start */
.zgt img {
  width: 100%;
  transition: all 0s;
}
.f_l .opacity1 {
  opacity: 1;
}
.f_r {
  display: inline-block;
  width: 42%;
  max-width: calc(100% - 658px);
  padding-top: 20px;
  /* background-color: pink; */
}
.f_r > ul {
  width: 94%;
  margin-left: auto;
  margin-right: 0;
  text-align: center;
}
.li_item {
  display: inline-block;
  width: calc(50% - 6px);
  height: 92px;
  min-height: 92px;
  margin-left: 6px;
  margin-bottom: 14px;
  background-color: #20adb8;
  vertical-align: top;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s;
}
.li_item:nth-child(4n-1),
.li_item:nth-child(4n) {
  background-color: #04999e;
}
.li_item:hover,
.f_r .li_item_active {
  /* background-color: #f08300; */
  background-color: #cba441;
}
.li_item > div {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.li_item span {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: white;
  line-height: 26px;
}
</style>